import { Box, Grid, Typography } from "@mui/material";
import { t } from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import SystemButton from "../../components/UIToolkit/SystemButton/SystemButton";
import { SURFACE } from "../../theme/tokens";

const PageNotFound: FC = () => {
	const navigate = useNavigate();

	return (
		<Grid container sx={{ minHeight: "calc(100vh - 120px)", width: "100%", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 2 }}>
			<Box>
				<Grid sx={{ justifyContent: "center", alignItems: "center", alignContent: "center" }}>
					<Typography style={{ textAlign: "center" }} variant="h1">
						404
					</Typography>
					<Typography style={{ textAlign: "center" }} variant="h4">
						{t("page.not.exist")}
					</Typography>
				</Grid>
			</Box>
			<Box>
				<img src="/page-not-found.png" alt="" style={{ width: "500px", maxWidth: "100%" }} />
			</Box>
			<SystemButton
				onClick={() => (document.referrer ? navigate(-1) : navigate("/"))}
				sx={(theme) => ({
					borderRadius: 10,
					backgroundColor: theme.palette.primary.light,
					margin: "20px auto 0px auto",
					color: SURFACE,
					cursor: "pointer",
					width: "fit-content",
				})}
			>
				{t("back.home")}
			</SystemButton>
		</Grid>
	);
};

export default PageNotFound;
